// @flow

export const APPROVAL_TIMEOUT_MS = 20 * 60 * 1000;

export function resolveWaitingDeadline(
  expiresInSeconds: ?number,
  now: number = Date.now(),
): number {
  if (typeof expiresInSeconds !== 'number' || !Number.isFinite(expiresInSeconds)) {
    return now + APPROVAL_TIMEOUT_MS;
  }

  return now + Math.max(0, expiresInSeconds) * 1000;
}

export function serverDeadline(
  expiresInSeconds: ?number,
  now: number = Date.now(),
): ?number {
  if (typeof expiresInSeconds !== 'number' || !Number.isFinite(expiresInSeconds)) {
    return null;
  }

  return now + Math.max(0, expiresInSeconds) * 1000;
}
